//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
import { useContext } from 'react';
import classNames from 'classnames';
import ReactPropTypes from 'prop-types';

import { FormContext } from './Form';

import * as patch from './PatchFunctions';

export function TextArea({
    name,
    id,
    value,
    className = "",
    disabled = false,
    readOnly = false,
    onChange,
    ...rest
}) {

    const { 
        initial, current, formId, formDisabled, formReadOnly, defaultOnChange,
    } = useContext(FormContext);

    // Extract the initial value for this named item in the form fields
    const initValue = patch.getPath(initial, name);

    // Use any parameters pass into this field
    const currId = id ? id : `${name}-${formId}`;
    const currValue = value ? value : patch.getPath(current, name);
    const currDisabled = disabled || formDisabled;
    const currReadOnly = readOnly || formReadOnly;

    const areaClass = classNames(
        'form-control',
        className,
        { 'is-dirty': currValue !== initValue }
    );

    return(
            <textarea
                className={areaClass}
                name={name}
                id={currId}
                value={currValue ? currValue : ""}
                onChange={(e) => defaultOnChange(e, onChange)}
                disabled={currDisabled}
                readOnly={currReadOnly}
                {...rest}
            />
    );
}

TextArea.propTypes = {
    name: ReactPropTypes.string.isRequired,
    value: ReactPropTypes.any,
    onChange: ReactPropTypes.func,
    required: ReactPropTypes.bool,
    disabled: ReactPropTypes.bool,
}

